module.exports = __webpack_public_path__ + "img/151.b33eebe7.png";